<template>
  <v-container fluid class="campaigns-overview">
    <v-layout row wrap class="py-0 my-0">
      <v-flex v-if="campaign">
        <span class="template-title">
          {{ campaign.name }}
          <h6 :class="setTextColor">Status: {{ campaign.status }}</h6>
        </span>
        <h6>Template: {{ campaign.message.template_message_name }}</h6>
      </v-flex>
      <v-spacer class="py-0 my-0" />
      <schedule-campaign
        class="py-0 my-0"
        v-if="campaign"
        style="width: auto"
        :campaign="campaign"
        @success="getCampaignData"
        @updated="getCampaignData"
      />
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <overall-campaigns-pie-chart
          :overall-data="overallData.msg_status"
          v-if="overallData.msg_status"
        />
      </v-flex>
      <v-flex xs6>
        <reply-back-status
          :reply-back-status="overallData.replyback_status"
          v-if="overallData.replyback_status"
        />
      </v-flex>

      <v-flex xs12>
        <receivers view="overview" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ScheduleCampaign from "@/components/campaign-manager/campaigns-crud/ScheduleCampaign";
import receivers from "../receivers-crud";
import overallCampaignsPieChart from "../sections/insights/overallCampaignsPieChart";
import replyBackStatus from "./replyBackStatus";
export default {
  name: "campaign-overview",
  components: {
    overallCampaignsPieChart,
    receivers,
    replyBackStatus,
    ScheduleCampaign,
  },
  data() {
    return {
      overallData: {},
      campaign: null,
    };
  },
  async mounted() {
    await this.getInsights();
    await this.getCampaignData();
  },
  computed: {
    setTextColor() {
      let classes = [];
      if (this.campaign) {
        let status = this.campaign.status.toLowerCase();

        switch (status) {
          case "draft":
            classes.push("purple--text");
            break;
          case "sent":
            classes.push("green--text");
            break;
          case "paused":
            classes.push("amber--text");
            break;
          case "canceled":
            classes.push("red--text");
            break;
          case "deleted":
            classes.push("red--text");
            break;
        }
        return classes;
      }
      return [];
    },
  },
  methods: {
    async getInsights() {
      const response = await this.$http_session_manager.get(
        `/campaigns/${this.$route.params.id}/analytics`
      );
      this.overallData = response.data;
    },
    async getCampaignData() {
      this.$store.dispatch("setLoader", true);
      const response = await this.$http_session_manager.get(
        `/campaigns/${this.$route.params.id}`
      );
      this.campaign = response.data;
      this.$store.commit("campaigns/select", response.data);
      this.$store.dispatch("setLoader", false);
    },
  },
};
</script>

<style scoped></style>
